var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f75082f3-4802-4637-a9b7-b192d6966f06",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-d8c09ae3-b5d9-48d5-8063-23616328e18f {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d8c09ae3-b5d9-48d5-8063-23616328e18f",
    d: "M19.34,22.97c-.24,0-.48-.08-.67-.25l-6.68-5.97c-.21-.19-.33-.46-.33-.75s.12-.56.33-.75l6.68-5.97c.41-.37,1.04-.33,1.41.08.37.41.33,1.04-.08,1.41l-5.84,5.23,5.84,5.23c.41.37.45,1,.08,1.41-.2.22-.47.33-.75.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.baa8bb104a199e88f71362be0ae82016.svg";
export { ForwardRef as ReactComponent };